// @material-ui/core components
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { SchoolRounded } from "@material-ui/icons";
import { unwrapResult } from '@reduxjs/toolkit';
import { Breadcrumb, Form, Input, notification, Select } from 'antd';
import "assets/css/styles.css";
import { grayColor } from "assets/jss/material-dashboard-pro-react";
import titleStyles from "assets/jss/material-dashboard-pro-react/components/adminNavbarStyle";
import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import Button from "components/CustomButtons/Button.js";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { fetchLevelPlos } from "reduxToolkit/features/levelPlo/LevelPloSlice";
import ErrorModal from "views/Components/ErrorModal";
import { addNewSubLevelPLos, fetchSubLevelPLos, fetchSubLevelPLosById, updateSubLevelPLos } from '../../../../reduxToolkit/features/SubLevelPlo/SubLevelPloSlice';

const useStyles = makeStyles(styles);

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 8,
  },
};

const tailLayout = {
  wrapperCol: {
    offset: 16,
    span: 16,
  },
};

export default function CreateSubLevelPlos({ match }) {

  const { id } = match.params

  const { t } = useTranslation();

  const isAddMode = isNaN(id);
  const classes = useStyles();
  const useTitleStyles = makeStyles(titleStyles);
  const [form] = Form.useForm();
  const titleClasses = useTitleStyles();

  const [level, setLevel] = useState("");
  const [code_level, setCode_level] = useState("");
  const [levelPlo_id, setLevelPlo_id] = useState("");
  const [addRequestStatus, setAddRequestStatus] = useState('idle')
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [handledError, setHandledError] = useState("");

  const dispatch = useDispatch()

  const subLevelPlo = useSelector((state) => state.subLevelPlo.subLevelPLo)
  const levelPlos = useSelector((state) => state.levelPlos.levelPlos)


  const history = useHistory();

  useEffect(() => {
    dispatch(fetchLevelPlos());
    if (!isAddMode) {
      dispatch(fetchSubLevelPLosById(id))
        .then(unwrapResult)
        .then((x) => {
          console.log(x, "x");
          form.setFieldsValue({
            level: x.level,
            code_level: x.code_level,
            levelPlo_id: x.levelPlo_id,
          });
        });
    }
  }, [id]);

  const handleOpenErrorModal = () => {
    setOpenErrorModal(true);
  };
  const handleCloseErrorModal = () => {
    setOpenErrorModal(false);
  };

  const openNotificationWithIcon = (type, msg) => {
    notification[type]({
      message: type,
      description: msg,
      top: 50,
      duration: 2,
    });
  };

  const onFinish = async (values) => {
    const resultAction = await dispatch(
      addNewSubLevelPLos({ ...values })
    );
    if (addNewSubLevelPLos.fulfilled.match(resultAction)) {
      openNotificationWithIcon("success", `Added successfully`);
      form.resetFields();
      dispatch(fetchSubLevelPLos());
      history.push(`/citrine/configuration/program/subLevelPlos`);
    } else {
      if (resultAction.payload) {
        setHandledError(resultAction.payload);
        handleOpenErrorModal();
      } else {
        setHandledError(resultAction.error);
        handleOpenErrorModal();
      }
    }
  };

  const onFinishUpdate = async (values) => {
    const resultAction = await dispatch(
      updateSubLevelPLos({
        id: id,
        modified: {
          ...values,
        },
      })
    );
    if (updateSubLevelPLos.fulfilled.match(resultAction)) {
      openNotificationWithIcon("success", `edit successfully`);
      form.resetFields();
      dispatch(fetchSubLevelPLos());
      history.push(`/citrine/configuration/program/subLevelPlos`);
    } else {
      if (resultAction.payload) {
        setHandledError(resultAction.payload);
        handleOpenErrorModal();
      } else {
        setHandledError(resultAction.error);
        handleOpenErrorModal();
      }
    }
  };

  return (
    <div>
      {isAddMode &&
        <div>
          <GridContainer style={{
            borderBottom: `1px solid  ${grayColor[15]}`,
            borderTop: `1px solid  ${grayColor[15]}`,
          }}
            justify="space-between"
            alignItems="center">
            <GridItem>
              <Breadcrumb separator=">">
                <Breadcrumb.Item >
                  {t('Configurations')}
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                  <Link to={`/citrine/configuration/program/`}>
                    <span > {t('Program Configurations')} </span>
                  </Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                  <Link to={`/citrine/configuration/program/SubLevelPlos/`}>
                    <span > {t('PLO Sub Levels')} </span>
                  </Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                  <span > {t('Create')} </span>
                </Breadcrumb.Item>
              </Breadcrumb>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <Card>
                <CardHeader color="info" icon>
                  <CardIcon color="info">
                    <SchoolRounded />
                  </CardIcon>
                  <h4 className={classes.cardIconTitle}>
                    <span className={titleClasses.title}>{t('Create ')}</span>
                  </h4>
                </CardHeader>
                <CardBody>
                  <Form
                    {...layout}
                    form={form}
                    name="control-hooks"
                    onFinish={onFinish}
                  >
                    <Form.Item
                      name="levelPlo_id"
                      label="Level"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Select placeholder="Select Level Plo" allowClear>
                        {levelPlos &&
                          levelPlos.map((r) => (
                            <option key={r.id} value={r.id}>
                              {r.level}
                            </option>
                          ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      name="level"
                      label="Sub Level"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Input style={{ width: "100%" }} />
                    </Form.Item>
                    <Form.Item
                      name="code_level"
                      label="Code"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Input style={{ width: "100%" }} />
                    </Form.Item>
                    <Form.Item {...tailLayout}>
                      <Button
                        type="primary"
                        style={{ marginRight: "20px" }}
                        color="primary"
                        onClick={() =>
                          history.push(`/citrine/configuration/program/subLevelPlos`)
                        }
                        htmlType="submit"
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        color="primary"
                      >
                        Submit
                      </Button>
                    </Form.Item>
                  </Form>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
          <ErrorModal
            open={openErrorModal}
            handleClose={handleCloseErrorModal}
            handledError={handledError}
          />
        </div>
      }
      {!isAddMode && subLevelPlo &&
        <div>
          <GridContainer style={{
            borderBottom: `1px solid  ${grayColor[15]}`,
            borderTop: `1px solid  ${grayColor[15]}`,
          }}
            justify="space-between"
            alignItems="center">
            <GridItem>
              <Breadcrumb separator=">">
                <Breadcrumb.Item >
                  {t('Configurations')}
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                  <Link to={`/citrine/configuration/program/`}>
                    <span > {t('Program Configurations')} </span>
                  </Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                  <Link to={`/citrine/configuration/program/SubLevelPlos/`}>
                    <span > {t('PLO Sub Levels')} </span>
                  </Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                  <span > {t('Update')} </span>
                </Breadcrumb.Item>
              </Breadcrumb>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <Card>
                <CardHeader color="info" icon>
                  <CardIcon color="info">
                    <SchoolRounded />
                  </CardIcon>
                  <h4 className={classes.cardIconTitle}>
                    <span className={titleClasses.title}>{t('Edit ')}</span>
                  </h4>
                </CardHeader>
                <CardBody>
                  <Form
                    {...layout}
                    form={form}
                    name="control-hooks"
                    onFinish={onFinishUpdate}
                  >
                    <Form.Item
                      name="levelPlo_id"
                      label="Level"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Select placeholder="Select Level Plo" allowClear>
                        {levelPlos &&
                          levelPlos.map((r) => (
                            <option key={r.id} value={r.id}>
                              {r.level}
                            </option>
                          ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      name="level"
                      label="Sub Level"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Input style={{ width: "100%" }} />
                    </Form.Item>
                    <Form.Item
                      name="code_level"
                      label="Code"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Input style={{ width: "100%" }} />
                    </Form.Item>
                    <Form.Item {...tailLayout}>
                      <Button
                        type="primary"
                        style={{ marginRight: "20px" }}
                        color="primary"
                        onClick={() =>
                          history.push(`/citrine/configuration/program/subLevelPlos`)
                        }
                        htmlType="submit"
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        color="primary"
                      >
                        Submit
                      </Button>
                    </Form.Item>
                  </Form>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
          <ErrorModal
            open={openErrorModal}
            handleClose={handleCloseErrorModal}
            handledError={handledError}
          />
        </div>
      }
    </div>
  );
}
